export default __webpack_public_path__ + "static/media/step-1-card-outline.c73336e4.svg";